import React from 'react';
import { Input } from 'reactstrap';

import dayjs, { dateTimeDisplayFormat } from '~libs/dayjs';

import { DateInput, MultiSelect } from '~components/form-fields/inputs';

import { CompanyAccessKey } from '~main/models';

import { useGetAccessTagsQuery } from '~support-at-home/actions/accessTags';

interface ComponentProps {
  isNew: boolean;
  handleFieldChange: (name: string, value: any) => void;
  values?: Partial<CompanyAccessKey>;
}

const ModalForm: React.FC<ComponentProps> = ({ isNew, handleFieldChange, values }) => {
  const { data: lookupTags } = useGetAccessTagsQuery();
  const permissionList =
    lookupTags?.map(({ id, module, name, permission }) => ({
      id,
      name: `${module}${name ? `-${name}` : ''}:${permission}`,
    })) ?? [];

  const { name, expires_at, tags, access_key } = values || {};

  if (!isNew) {
    return (
      <div>
        <div className="row mb-2">
          <div className="col-3">
            <strong>Access Key:</strong>
          </div>
          <div className="col-9 text-end">{access_key}</div>
        </div>
        <div className="row mb-2">
          <div className="col-3">
            <strong>Expires At:</strong>
          </div>
          <div className="col-9 text-end">{expires_at ? dayjs(expires_at).format(dateTimeDisplayFormat) : 'N/A'}</div>
        </div>
        <div className="row">
          <div className="col-3">
            <strong>Tags:</strong>
          </div>
          <div className="col-9">
            {tags && tags.length > 0 ? (
              <ul className="list-unstyled mb-0 text-end">
                {tags.map((tagRow) => (
                  <li key={tagRow.id}>{tagRow.tag?.access_tag}</li>
                ))}
              </ul>
            ) : (
              <div className="text-end">N/A</div>
            )}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="row align-items-center mb-2">
        <div className="col-2">
          <span>Name</span>
        </div>
        <div className="col-10">
          <Input
            id="name"
            type="text"
            value={name || ''}
            onChange={({ target }) => handleFieldChange(target.name, target.value)}
            name="name"
            required
            className="mb-1"
          />
        </div>
      </div>
      <div className="row align-items-center mb-2">
        <div className="col-2">
          <span>Expiration Date</span>
        </div>
        <div className="col-10">
          <DateInput
            id="expires_at"
            name="expires_at"
            type="date"
            value={expires_at || ''}
            onChange={handleFieldChange}
            className="mb-2"
          />
        </div>
      </div>
      <div className="row align-items-center mb-2">
        <div className="col-2">
          <span>Tags</span>
        </div>
        <div className="col-10">
          <MultiSelect
            id="tags"
            name="tags"
            type="text"
            options={permissionList}
            value={tags || []}
            setFieldValue={handleFieldChange}
            className="mb-2"
          />
        </div>
      </div>
    </div>
  );
};

export default ModalForm;
